<template>
  <div>
    <div class="service-container" style="margin-top: 8px;">
      <img class="service-main-img" src="@/assets/img/技术支持.png" alt="技术支持主图" loading="eager" />
    </div>
    <div class="calculator-container">
      <div class="header">
        <h1>计算器工具</h1>
        <p class="subtitle">选择您需要的计算工具</p>
      </div>

      <div class="tools-grid">
        <div class="tool-card" @click="navigateTo('/support/calculator')">
          <div class="tool-icon">
            <i class="el-icon-s-grid"></i>
          </div>
          <h3>多肽计算器(专业版)</h3>
          <p>计算多肽的分子量、等电点、亲水性、溶解性等详细信息</p>
          <el-button type="primary" round>进入计算器</el-button>
        </div>

        <div class="tool-card" @click="navigateTo('/support/content-calculator')">
          <div class="tool-icon">
            <i class="el-icon-s-data"></i>
          </div>
          <h3>肽含量计算器</h3>
          <p>根据分子量、酸碱基团、盐类型和纯度计算肽含量百分比</p>
          <el-button type="success" round>进入计算器</el-button>
        </div>
      </div>
    </div>

    <!-- 底部信息 -->
    <div class="tk-footer">
      <div>电话：15002819872&nbsp; 邮箱：15002819872@163.com&nbsp; 地址：江西省赣州市章贡区长征大道12号</div>
      <div>备案号: <a href="https://beian.miit.gov.cn/#/Integrated/index">赣ICP备2026004521号-1</a></div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Support',
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped>
.service-container {
  width: 100%;
  overflow: hidden;
}

.service-main-img {
  width: 100%;
  height: auto;
  max-height: 400px;
  object-fit: cover;
  display: block;
}

.calculator-container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.header {
  text-align: center;
  margin-bottom: 40px;
  border-bottom: 2px solid #409EFF;
  padding-bottom: 20px;
}

.header h1 {
  color: #303133;
  margin: 0 0 10px 0;
  font-size: 28px;
}

.subtitle {
  color: #909399;
  margin: 0;
  font-size: 14px;
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 30px;
  width: 100%;
}

.tool-card {
  background: #fff;
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.tool-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(64, 158, 255, 0.3);
  border-color: #409EFF;
}

.tool-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  transition: all 0.3s ease;
}

.tool-card:hover .tool-icon {
  transform: scale(1.1);
}

.tool-card h3 {
  margin: 0 0 15px 0;
  font-size: 20px;
  color: #303133;
  font-weight: 600;
}

.tool-card p {
  margin: 0 0 25px 0;
  color: #606266;
  font-size: 14px;
  line-height: 1.6;
}

.tk-footer {
  background: #2f2f2f;
  color: #fff;
  text-align: center;
  padding: 30px 0 10px 0;
  margin-top: 40px;
}

.tk-footer div {
  margin: 5px 0;
  font-size: 14px;
}
.tk-footer a {
  color: #fff;
  text-decoration: none;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .service-main-img {
    max-height: 250px;
    object-fit: contain;
  }

  .tk-footer {
    padding: 20px 10px 10px 10px;
    margin-top: 20px;
    font-size: 12px;
    line-height: 1.6;
  }

  .tk-footer div {
    word-break: break-all;
    padding: 0 5px;
  }

  .calculator-container {
    margin: 10px;
    padding: 15px;
  }

  .header h1 {
    font-size: 22px;
  }

  .subtitle {
    font-size: 12px;
  }

  .tools-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .tool-card {
    padding: 20px;
  }

  .tool-icon {
    width: 60px;
    height: 60px;
    font-size: 30px;
  }

  .tool-card h3 {
    font-size: 18px;
  }

  .tool-card p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .service-main-img {
    max-height: 180px;
  }

  .header h1 {
    font-size: 18px;
  }

  .calculator-container {
    margin: 5px;
    padding: 10px;
  }

  .header {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }

  .tool-card {
    padding: 15px;
  }
}
</style>

